import 'babel-polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
